// export default NormalTable;
import React, { useEffect } from "react";
import $ from "jquery";
import "datatables.net";
import { useNavigate } from "react-router-dom"; // ✅ add this import

const NormalTable = ({ tableId, ajaxUrl, columns }) => {
  const navigate = useNavigate(); // ✅ initialize navigate

  useEffect(() => {
    let dataTableInstance;

    const loadScriptAndInitialize = async () => {
      try {
        const module = await import("../../../datatable.js"); // Dynamically import
        const initFunc = module.initializeDataTable || window.initializeDataTable;

        if (typeof initFunc === "function") {
          dataTableInstance = initFunc({
            selector: `#${tableId}`,
            columns,
            ajaxUrl,
            footerCallback: function (row, data, start, end, display) {
              var api = this.api();
              var json = api.ajax.json();

              const updateCell = (colIndex, htmlContent) => {
                let cell = $(api.column(colIndex).footer());
                let titleSpan = cell.find('.dt-column-title');
                if (titleSpan.length) {
                  titleSpan.html(htmlContent);
                } else {
                  cell.html(htmlContent);
                }
              };

              if (json && json.total_amount) {
                updateCell(0, '<strong>Total</strong>');
                updateCell(1, '<strong>' + json.total_amount + '</strong>');
              } else {
                var intVal = function (i) {
                  if (typeof i === 'string') {
                    let str = i.replace(/[₹,%\s]/g, '').toUpperCase();
                    if (str.endsWith('CR')) return parseFloat(str.replace('CR', '')) * 10000000;
                    if (str.endsWith('L')) return parseFloat(str.replace('L', '')) * 100000;
                    if (str.endsWith('K')) return parseFloat(str.replace('K', '')) * 1000;
                    return parseFloat(str) || 0;
                  }
                  return typeof i === 'number' ? i : 0;
                };

                // Total over this page for the 'Amount' column (index 1)
                var total = api
                  .column(1, { page: 'current' })
                  .data()
                  .reduce(function (a, b) {
                    return intVal(a) + intVal(b);
                  }, 0);

                // Update footer
                updateCell(0, '<strong>Total</strong>');
                updateCell(1, '<strong>₹' + total.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '</strong>');
              }

              // Put '-' in all remaining columns
              api.columns().every(function () {
                var colIdx = this.index();
                if (colIdx > 1) {
                  updateCell(colIdx, '<strong>-</strong>');
                }
              });
            }
          });
        }

        // ✅ Click handler for invoice number
        $(document).on("click", `#${tableId} .invoice-number`, function () {
          const invoiceId = $(this).data("invoice-id");
          if (invoiceId) {
            navigate(`/billing-section/${invoiceId}`);
          }
        });
      } catch (error) {
        console.error("Failed to load or initialize datatable.js:", error);
      }
    };

    loadScriptAndInitialize();

    return () => {
      // Clean up on unmount
      if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
        $(`#${tableId}`).DataTable().destroy(true);
      }

      // ✅ Remove event listener to avoid duplicates
      $(document).off("click", `#${tableId} .invoice-number`);
    };
  }, [tableId, ajaxUrl, columns, navigate]);

  return (
    <>      
    <h5 className="kpi-heading">Invoices</h5>
      <table id={tableId} className="display">
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th key={index}>{col.title || col.data}</th>
            ))}
          </tr>
        </thead>
        <tfoot className="table-footer" style={{ fontWeight: "bold" }}>
          <tr>
            {columns.map((col, index) => (
              <td key={index} className={index === 0 ? "sticky-col name-col table-header-content" : "table-header-content"} style={index === 0 ? { backgroundColor: "#ffffff", borderRight: "1px solid #dee2e6", padding: "7px" } : { padding: "7px" }}>
                {index === 0 ? <strong>Total</strong> : index === 1 ? "" : <strong>-</strong>}
              </td>
            ))}
          </tr>
        </tfoot>
      </table>
    </>
  );
};

export default NormalTable;

